import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-599499a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "question-bank-page"
};
const _hoisted_2 = {
  class: "page-header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h1", null, "文字推理题库"), /*#__PURE__*/_createElementVNode("p", null, "管理图片题与文字类比题。已发布题目需复制为草稿后修改。")], -1));
const _hoisted_4 = {
  class: "workspace"
};
const _hoisted_5 = {
  class: "group-panel"
};
const _hoisted_6 = {
  class: "group-actions"
};
const _hoisted_7 = {
  class: "content-panel"
};
const _hoisted_8 = {
  class: "toolbar"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "toolbar-spacer"
}, null, -1));
const _hoisted_10 = {
  class: "summary-line"
};
const _hoisted_11 = {
  class: "question-list"
};
const _hoisted_12 = {
  class: "card-head"
};
const _hoisted_13 = {
  class: "meta-row"
};
const _hoisted_14 = {
  class: "question-number"
};
const _hoisted_15 = {
  key: 1,
  class: "version"
};
const _hoisted_16 = {
  class: "card-actions"
};
const _hoisted_17 = {
  class: "answer-summary"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "正确答案：", -1));
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "解析：", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_LeftGroupList = _resolveComponent("LeftGroupList");
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_TextLogicalReasoningQuestion = _resolveComponent("TextLogicalReasoningQuestion");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_TextAnalogyQuestionForm = _resolveComponent("TextAnalogyQuestionForm");
  const _component_el_drawer = _resolveComponent("el-drawer");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_hoisted_3, _createVNode(_component_el_button, {
    type: "primary",
    disabled: !$data.groupId,
    onClick: $options.createAnalogy
  }, {
    default: _withCtx(() => [_createTextVNode("新增文字类比题")]),
    _: 1
  }, 8, ["disabled", "onClick"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("aside", _hoisted_5, [_createVNode(_component_LeftGroupList, {
    "group-title": "文字推理分组",
    data: $data.groups,
    onChoose: $options.onChoose
  }, null, 8, ["data", "onChoose"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_ButtonDialog, {
    "btn-id": 27,
    "btn-name": "+ 新增分组",
    style: 1,
    size: "small",
    onFresh: $options.initGroups
  }, null, 8, ["onFresh"]), $data.groupId ? (_openBlock(), _createBlock(_component_el_popconfirm, {
    key: 0,
    title: "组内题目也会一起删除，确定吗？",
    onConfirm: $options.deleteGroup
  }, {
    reference: _withCtx(() => [_createVNode(_component_el_button, {
      text: "",
      type: "danger",
      size: "small"
    }, {
      default: _withCtx(() => [_createTextVNode("删除当前组")]),
      _: 1
    })]),
    _: 1
  }, 8, ["onConfirm"])) : _createCommentVNode("", true)])]), _createElementVNode("main", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_radio_group, {
    modelValue: $data.filters.contentMode,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.filters.contentMode = $event),
    onChange: $options.resetAndFetch
  }, {
    default: _withCtx(() => [_createVNode(_component_el_radio_button, {
      label: ""
    }, {
      default: _withCtx(() => [_createTextVNode("全部")]),
      _: 1
    }), _createVNode(_component_el_radio_button, {
      label: "IMAGE"
    }, {
      default: _withCtx(() => [_createTextVNode("图片题")]),
      _: 1
    }), _createVNode(_component_el_radio_button, {
      label: "VERBAL_ANALOGY"
    }, {
      default: _withCtx(() => [_createTextVNode("文字类比")]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "onChange"]), _createVNode(_component_el_select, {
    modelValue: $data.filters.publishStatus,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.filters.publishStatus = $event),
    clearable: "",
    placeholder: "全部状态",
    class: "status-select",
    onChange: $options.resetAndFetch
  }, {
    default: _withCtx(() => [_createVNode(_component_el_option, {
      label: "草稿",
      value: "DRAFT"
    }), _createVNode(_component_el_option, {
      label: "已发布",
      value: "PUBLISHED"
    }), _createVNode(_component_el_option, {
      label: "已归档",
      value: "ARCHIVED"
    })]),
    _: 1
  }, 8, ["modelValue", "onChange"]), _createVNode(_component_el_input, {
    modelValue: $data.filters.keyword,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.filters.keyword = $event),
    clearable: "",
    placeholder: "搜索题干或选项",
    class: "search-input",
    onKeyup: _withKeys($options.resetAndFetch, ["enter"]),
    onClear: $options.resetAndFetch
  }, null, 8, ["modelValue", "onKeyup", "onClear"]), _createVNode(_component_el_button, {
    onClick: $options.resetAndFetch
  }, {
    default: _withCtx(() => [_createTextVNode("查询")]),
    _: 1
  }, 8, ["onClick"]), _hoisted_9, _createVNode(_component_ButtonDialog, {
    "btn-id": 28,
    "btn-name": "上传题目包",
    "init-data": {
      groupId: $data.groupId
    },
    onFresh: $options.fetchList
  }, null, 8, ["init-data", "onFresh"]), _createVNode(_component_ButtonDialog, {
    "btn-id": 32,
    "btn-name": "上传图片题",
    "init-data": {
      groupId: $data.groupId
    },
    onFresh: $options.fetchList
  }, null, 8, ["init-data", "onFresh"])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString($options.currentGroupName || '请选择分组'), 1), _createElementVNode("span", null, "共 " + _toDisplayString($data.total) + " 题", 1)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [!$data.loading && $data.questions.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
    key: 0,
    description: "当前筛选条件下暂无题目"
  }, {
    default: _withCtx(() => [$data.groupId ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      type: "primary",
      onClick: $options.createAnalogy
    }, {
      default: _withCtx(() => [_createTextVNode("新增文字类比题")]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions, (question, index) => {
    return _openBlock(), _createElementBlock("article", {
      key: question.id,
      class: "question-card"
    }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, "第 " + _toDisplayString($data.page * $data.pageSize + index + 1) + " 题", 1), _createVNode(_component_el_tag, {
      size: "small",
      effect: "plain"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($options.modeLabel(question.contentMode)), 1)]),
      _: 2
    }, 1024), question.contentMode === 'VERBAL_ANALOGY' ? (_openBlock(), _createBlock(_component_el_tag, {
      key: 0,
      size: "small",
      type: $options.statusTagType(question.publishStatus),
      effect: "light"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($options.statusLabel(question.publishStatus)), 1)]),
      _: 2
    }, 1032, ["type"])) : _createCommentVNode("", true), question.versionNo ? (_openBlock(), _createElementBlock("span", _hoisted_15, "v" + _toDisplayString(question.versionNo), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [question.contentMode === 'VERBAL_ANALOGY' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [question.publishStatus === 'DRAFT' ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      text: "",
      type: "primary",
      onClick: $event => $options.editAnalogy(question)
    }, {
      default: _withCtx(() => [_createTextVNode("编辑")]),
      _: 2
    }, 1032, ["onClick"])) : _createCommentVNode("", true), question.publishStatus === 'DRAFT' ? (_openBlock(), _createBlock(_component_el_button, {
      key: 1,
      text: "",
      type: "success",
      onClick: $event => $options.publish(question)
    }, {
      default: _withCtx(() => [_createTextVNode("发布")]),
      _: 2
    }, 1032, ["onClick"])) : _createCommentVNode("", true), question.publishStatus !== 'DRAFT' ? (_openBlock(), _createBlock(_component_el_button, {
      key: 2,
      text: "",
      type: "primary",
      onClick: $event => $options.copyAsDraft(question)
    }, {
      default: _withCtx(() => [_createTextVNode("复制为草稿")]),
      _: 2
    }, 1032, ["onClick"])) : _createCommentVNode("", true), question.publishStatus === 'PUBLISHED' ? (_openBlock(), _createBlock(_component_el_button, {
      key: 3,
      text: "",
      type: "warning",
      onClick: $event => $options.archive(question)
    }, {
      default: _withCtx(() => [_createTextVNode("归档")]),
      _: 2
    }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $options.canDelete(question) ? (_openBlock(), _createBlock(_component_el_popconfirm, {
      key: 1,
      title: "确定删除这道题吗？",
      onConfirm: $event => $options.deleteQuestion(question)
    }, {
      reference: _withCtx(() => [_createVNode(_component_el_button, {
        text: "",
        type: "danger"
      }, {
        default: _withCtx(() => [_createTextVNode("删除")]),
        _: 1
      })]),
      _: 2
    }, 1032, ["onConfirm"])) : _createCommentVNode("", true)])]), _createVNode(_component_TextLogicalReasoningQuestion, {
      question: question
    }, null, 8, ["question"]), _createElementVNode("div", _hoisted_17, [_createElementVNode("span", null, [_hoisted_18, _createTextVNode(_toDisplayString(question.rightAnswer), 1)]), question.analysisText ? (_openBlock(), _createElementBlock("span", _hoisted_19, [_hoisted_20, _createTextVNode(_toDisplayString(question.analysisText), 1)])) : _createCommentVNode("", true)])]);
  }), 128))])), [[_directive_loading, $data.loading]]), $data.total > $data.pageSize ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 0,
    "current-page": $data.currentPage,
    "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => $data.currentPage = $event),
    "page-size": $data.pageSize,
    total: $data.total,
    layout: "prev, pager, next, total",
    class: "pagination",
    onCurrentChange: $options.fetchList
  }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])) : _createCommentVNode("", true)])]), _createVNode(_component_el_drawer, {
    modelValue: $data.drawerVisible,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.drawerVisible = $event),
    title: $data.editingQuestion ? '编辑文字类比草稿' : '新增文字类比题',
    size: "88%",
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [$data.drawerVisible ? (_openBlock(), _createBlock(_component_TextAnalogyQuestionForm, {
      key: 0,
      question: $data.editingQuestion,
      "group-id": Number($data.groupId),
      onSaved: $options.onDraftSaved,
      onCancel: _cache[4] || (_cache[4] = $event => $data.drawerVisible = false)
    }, null, 8, ["question", "group-id", "onSaved"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "title"])]);
}